import { Typography, Counter, Button } from '@ui/components';
import { Link } from 'react-router-dom';
import { cn } from '@ui/utils';
import React from 'react';

export interface DashboardCardHeaderProps extends React.HTMLAttributes<HTMLDivElement> {
  title?: string;
  icon?: React.ReactNode;
  counter?: number;
  link?: {
    label: string;
    href: string;
  };
  isLinkVisible?: boolean;
  action?: React.ReactNode;
}

export const DashboardCardHeader = (props: DashboardCardHeaderProps) => {
  const { title, link, icon, className, counter, action, isLinkVisible, ...rest } = props;

  return (
    <div className={cn('w-full flex justify-between items-center gap-4', className)} {...rest}>
      <div className="flex items-center gap-2">
        {icon && <div className="flex items-center justify-center w-6 h-6 text-weak">{icon}</div>}
        {title && <Typography variant="h200">{title}</Typography>}
        {!!counter && <Counter variant="default">{counter}</Counter>}
      </div>
      {isLinkVisible && link && (
        <Button className="p-0" variant="link" asChild>
          <Link to={link.href}>{link.label}</Link>
        </Button>
      )}
      {action && action}
    </div>
  );
};
